// src/pages/GalleryPage.js
import React, { useState } from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  SimpleGrid,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  useColorModeValue,
  Image,
  AspectRatio,
  Icon,
  Flex,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FaPlayCircle, FaImage } from 'react-icons/fa';

import gallery_1 from '../assets/gallery_1.jpg';
import gallery_2 from '../assets/gallery_2.jpg';
import gallery_3 from '../assets/gallery_3.jpg';
import gallery_4 from '../assets/gallery_4.jpg';
import gallery_5 from '../assets/gallery_5.jpg';
import gallery_6 from '../assets/gallery_6.jpg';
import gallery_7 from '../assets/gallery_7.jpg';
import gallery_8 from '../assets/gallery_8.jpg';
import gallery_9 from '../assets/gallery_9.jpg';
import edris_group from '../assets/edris_group.jpeg';
import city_court from '../assets/city_court.webp';
import river_bridge from '../assets/river_bridge.webp';
import building_2 from '../assets/building_2.png';
import building_1 from '../assets/building_.jpg';
import mission from '../assets/mission.png';
import group_celebration from '../assets/group_celebration.jpg';
import group_photo from '../assets/group_photo.jpg';
import bale_man_clear from '../assets/bale_man_clear.jpeg';
import edris_3 from '../assets/edris_3.jpg';


// --- MOCK DATA FOR YOUR GALLERY ---
// Add your own image and video links here.
// For videos, use the "embed" link from YouTube/Vimeo.
const galleryData = [
  {
    id: 1,
    type: 'image',
    thumbnailSrc: gallery_2,
    fullSrc:gallery_2 ,
    title: 'Commercial Building Facade',
  },
   {
    id: 1,
    type: 'image',
    thumbnailSrc: gallery_3,
    fullSrc:gallery_3 ,
    title: 'Commercial Building Facade',
  },
   {
    id: 1,
    type: 'image',
    thumbnailSrc: gallery_6,
    fullSrc:gallery_6,
    title: 'Commercial Building Facade',
  },
   {
    id: 1,
    type: 'image',
    thumbnailSrc: gallery_4,
    fullSrc:gallery_4 ,
    title: 'Commercial Building Facade',
  },
   {
    id: 1,
    type: 'image',
    thumbnailSrc: gallery_5,
    fullSrc:gallery_5,
    title: 'Commercial Building Facade',
  },
    {
    id: 1,
    type: 'image',
    thumbnailSrc: edris_group,
    fullSrc:edris_group,
    title: 'Commercial Building Facade',
  },  
  {
    id: 1,
    type: 'image',
    thumbnailSrc: building_2,
    fullSrc:building_2,
    title: 'Commercial Building Facade',
  },  {
    id: 1,
    type: 'image',
    thumbnailSrc: city_court,
    fullSrc:city_court,
    title: 'Commercial Building Facade',
  },  {
    id: 1,
    type: 'image',
    thumbnailSrc: gallery_7,
    fullSrc:gallery_7,
    title: 'Commercial Building Facade',
  },
   {
    id: 1,
    type: 'image',
    thumbnailSrc: gallery_8,
    fullSrc:gallery_8,
    title: 'Commercial Building Facade',
  },
   {
    id: 1,
    type: 'image',
    thumbnailSrc: gallery_9,
    fullSrc:gallery_9,
    title: 'Commercial Building Facade',
  },
   {
    id: 1,
    type: 'image',
    thumbnailSrc: river_bridge,
    fullSrc:river_bridge,
    title: 'Commercial Building Facade',
  },
   {
    id: 1,
    type: 'image',
    thumbnailSrc: mission,
    fullSrc:mission,
    title: 'Commercial Building Facade',
  },
  {
    id: 1,
    type: 'image',
    thumbnailSrc: edris_3,
    fullSrc:edris_3,
    title: 'Commercial Building Facade',
  },
  {
    id: 1,
    type: 'image',
    thumbnailSrc: bale_man_clear,
    fullSrc:bale_man_clear,
    title: 'Commercial Building Facade',
  },
  {
    id: 1,
    type: 'image',
    thumbnailSrc: gallery_1,
    fullSrc:gallery_1,
    title: 'Commercial Building Facade',
  },
   {
    id: 1,
    type: 'image',
    thumbnailSrc: group_celebration,
    fullSrc:group_celebration,
    title: 'Commercial Building Facade',
  },
  {
    id: 1,
    type: 'image',
    thumbnailSrc: group_photo,
    fullSrc:group_photo,
    title: 'Commercial Building Facade',
  },
    {
    id: 2,
    type: 'video',
    thumbnailSrc: 'https://i3.ytimg.com/vi/I2IpYLB61Ic/maxresdefault.jpg',
    fullSrc: 'https://www.youtube.com/embed/I2IpYLB61Ic', // Example YouTube embed link
    title: 'Construction Time-Lapse',
  },
  {
    id: 2,
    type: 'video',
    thumbnailSrc: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-xoa21oYjmobQ-1nhv3bFKKgerLfWywN-Pw&s',
    fullSrc: 'https://www.youtube.com/embed/0zimlc1znRQ', // Example YouTube embed link
    title: 'Construction Time-Lapse',
  },

];

// A reusable component for each item in the grid
const GalleryItem = ({ item, onClick }) => {
  return (
    <Box
      position="relative"
      borderRadius="xl"
      overflow="hidden"
      boxShadow="lg"
      cursor="pointer"
      onClick={() => onClick(item)}
      transition="all 0.3s"
      _hover={{ transform: 'scale(1.05)', boxShadow: 'xl' }}
    >
      <AspectRatio ratio={4 / 3}>
        <Image src={item.thumbnailSrc} alt={item.title} objectFit="cover" />
      </AspectRatio>
      <Flex
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="blackAlpha.600"
        align="center"
        justify="center"
        opacity="0"
        _hover={{ opacity: 1 }}
        transition="opacity 0.3s"
      >
        <Icon as={item.type === 'video' ? FaPlayCircle : FaImage} boxSize={16} color="white" />
      </Flex>
    </Box>
  );
};

export default function GalleryPage() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    onOpen();
  };

  return (
    <>
      <Header />
      <Box as="main" bg={bgColor}>
        <VStack maxW="7xl" mx="auto" px={8} spacing={12} py={{ base: 16, md: 24 }}>
          {/* Page Header */}
          <VStack spacing={4} textAlign="center">
            <Breadcrumb>
              <BreadcrumbItem>
                <BreadcrumbLink as={RouterLink} to="/">Home</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink href="#">Gallery</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
            <Heading as="h1" size="2xl" fontWeight="extrabold">
              Our Work in Action
            </Heading>
            <Text maxW="3xl" color="gray.600">
            Explore a collection of our projects, showcasing our commitment to quality, innovation, and structural excellence.
            </Text>
          </VStack>

          {/* Gallery Grid */}
          <SimpleGrid columns={{ base: 1, sm: 2, lg: 3, xl: 4 }} spacing={8} w="full">
            {galleryData.map((item) => (
              <GalleryItem key={item.id} item={item} onClick={handleItemClick} />
            ))}
          </SimpleGrid>
        </VStack>
      </Box>

      {/* The Modal for displaying the full-size image or video */}
      {selectedItem && (
        <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
          <ModalOverlay bg="blackAlpha.800" />
          <ModalContent bg="transparent" boxShadow="none">
            {/* <ModalHeader color="white">{selectedItem.title}</ModalHeader> */}
            <ModalCloseButton color="white" bg="blackAlpha.500" _hover={{ bg: 'blackAlpha.700' }} />
            <ModalBody>
              {selectedItem.type === 'image' ? (
                <Image src={selectedItem.fullSrc} alt={selectedItem.title} borderRadius="lg" />
              ) : (
                <AspectRatio ratio={16 / 9}>
                  <iframe
                    title={selectedItem.title}
                    src={selectedItem.fullSrc}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </AspectRatio>
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      )}

      <Footer />
    </>
  );
}